import React from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import BackNextButtons from "../../../../shared/components/BackNextButtons.jsx";
import GetHelp from "../../../../shared/components/GetHelp.jsx";
import { clearAllAction } from "../../../../redux/actions";
import { checkHealthAction } from "../../../../redux/reducers/apiReducers/getServicesReducer";

const PrivacyNoticeView = ({ t, i18n }) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  // const [errMsg, setErrMsg] = useState('')

  const onNext = () => {
    try {
      // Validate then push to next route EX:
      const healthCheckPromise = dispatch(checkHealthAction());
      healthCheckPromise.then((result) => {
        if (result === "UP") {
          dispatch(clearAllAction());
          navigate(`/${i18n.language}${t("routes.start_page")}`);
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  const backNextProps = {
    prevText: t("shared.back"),
    // prevURL: `/${i18n.language}${t('routes.select_location')}`,
    nextText: t("shared.next"),
    nextOnClick: onNext
  };

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>

            <div className="row">
              <div className="col-xs-12">
                <h1>{t("privacy_notice.title")}</h1>
                <p>{t("privacy_notice.para_1")}</p>
                <p>{t("privacy_notice.para_2")}</p>
                <p>{t("privacy_notice.para_3")}</p>
                <p>
                  {t("privacy_notice.para_4")}
                  <a href={`mailto:${t("privacy_notice.contact_us_email")}`}>
                    {t("privacy_notice.contact_us_email")}
                  </a>
                  {t("privacy_notice.para_4_cont")}
                </p>
              </div>
            </div>
            <BackNextButtons
              props={backNextProps}
              displayBack={false}
              nextOnClick={onNext}
              isGreenButton={false}
            />
            <GetHelp />
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(PrivacyNoticeView);
